<template>
<v-select :options="values.length < 3 ? buildingList : []" v-model="values" :value="value" @input="update" multiple placeholder="Select maximum 3 buildings" :onChange="onChange"></v-select>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'BuildingSelect',
  props: {
    value: [String, Object, Array],
    change: {
      type: Function
    }
  },
  computed: {
    buildingList() {
      return Vue._.map(this.$store.state.buildings.simple, (building) => {
        return {
          label: building.name,
          value: building.id
        }
      })
    }
  },
  data: function () {
    return {
      values: [],
    }
  },
  methods: {
    update(val) {
      this.$emit('input', val)
    },
    onChange(val) {
      if (this.change) {
        this.change(val)
      }
    }
  },
  created() {
    if (this.$store.state.buildings.simple.length == 0) {
      this.$store.dispatch('buildings/getSimpleBuildings')
    }
  },
}
</script>
